import { formatAmount } from "../../../../utils/appUtils";
import dayjs from "dayjs";
import { Tooltip } from "antd";

export const PAY_PENALTY = "PAY_PENALTY";
export const REFUND_TO_CUSTOMER = "REFUND_TO_CUSTOMER";

const rowStyle = { margin: 0, padding: "5px 0" };

export const PENALTY_TAB_DATA = [
    { label: "Penalty", content: "PENALTY", key: "1" },
    { label: "Refund", content: "REFUND", key: "2" }
];

export const PENALTY_COLUMNS = [
    {
        title: "SNo",
        width: 50,
        align: "center",
        render: (_, detail, index) => <>{index + 1}</>
    },
    {
        title: "Advocate Name",
        width: 200,
        dataIndex: "lawyerName",
        key: "lawyerName",
        render: (text) => <p style={rowStyle}>{text || "Nil"}</p>
    },
    {
        title: "Advocate ID",
        width: 120,
        dataIndex: "lawyerNo",
        key: "lawyerNo",
        render: (text) => <p style={rowStyle}>{text || "Nil"}</p>
    },
    {
        title: "Payment date",
        width: 150,
        dataIndex: "transactionDate",
        key: "transactionDate",
        render: (text) => <p style={rowStyle}>{text ? dayjs(text).format("DD-MM-YYYY") : "Nil"}</p>
    },
    {
        title: "Payment ID",
        width: 200,
        dataIndex: "transactionId",
        key: "transactionId",
        render: (text) => <p style={rowStyle}>{text || "Nil"}</p>
    },
    {
        title: "Amount",
        width: 120,
        dataIndex: "amount",
        key: "amount",
        align: "center",
        render: (text) => <p style={{ ...rowStyle }}>{text ? `₹${formatAmount(text)}` : "Nil"}</p>
    }
];

export const REFUND_COLUMNS = [
    {
        title: "SNo",
        width: 60,
        align: "center",
        render: (_, detail, index) => <>{index + 1}</>
    },
    {
        title: "Customer Name",
        width: 200,
        dataIndex: "customerName",
        key: "customerName",
        render: (text) => <p style={rowStyle}>{text || "Nil"}</p>
    },
    {
        title: "Customer ID",
        width: 120,
        dataIndex: "customerNo",
        key: "customerNo",
        render: (text) => <p style={rowStyle}>{text || "Nil"}</p>
    },
    {
        title: "Payment date",
        width: 150,
        dataIndex: "transactionDate",
        key: "transactionDate",
        render: (text) => <p style={rowStyle}>{text ? dayjs(text).format("DD-MM-YYYY") : "Nil"}</p>
    },
    {
        title: "Payment ID",
        width: 200,
        dataIndex: "transactionId",
        key: "transactionId",
        render: (text) => <p style={rowStyle}>{text || "Nil"}</p>
    },
    {
        title: "Amount",
        width: 120,
        dataIndex: "amount",
        key: "amount",
        align: "center",
        render: (text) => <p style={{ ...rowStyle }}>{text ? `₹${formatAmount(text)}` : "Nil"}</p>
    },
    {
        title: "Reason",
        dataIndex: "reason",
        key: "reason",
        width: 250,
        render: (text) => {
            if (!text) return <p style={rowStyle}>Nil</p>;
            if (text?.length > 250) {
                return (
                    <Tooltip title={text} placement="topLeft">
                        <p style={{ ...rowStyle, cursor: "pointer" }}>{text?.substring(0, 250)}...</p>
                    </Tooltip>
                );
            }
            return <p style={rowStyle}>{text}</p>;
        }
    }
];
